import { FirebaseError } from 'firebase/app';

import { useToast } from '../../toast/Toast.context';

export const useFirebaseErrorHandler = () => {
  const { showToast } = useToast();

  const handleFirebaseError = (error: FirebaseError) => {
    switch (error.code) {
      case 'auth/invalid-credential':
        showToast({
          message:
            "L'email ou le mot de passe utilisé n'est pas correcte. Réessaye",
          type: 'error',
        });
        break;
      case 'auth/email-already-in-use':
        showToast({
          message:
            "L'email que vous avez fourni est déjà utilisé. Veuillez vous connecter ou réinitialiser votre mot de passe.",
          type: 'error',
        });
        break;
      default:
        showToast({
          message: `Une erreur est survenue : ${error.code}`,
          type: 'error',
        });
    }
  };

  return { handleFirebaseError };
};
